import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject, options: IGenericObject = {}) => {
  const fillSmallerScreens = options.fillSmallerScreens;
  const preventScroll = options.preventScroll;

  return StyleSheet.create({
    modalContent: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      background: styles.modalContent?.background ?? '#FFF',
      padding: styles.modalContent?.mobile?.padding ?? '80px 20px',
      borderRadius: fillSmallerScreens ? 0 : styles.modalContent?.borderRadius ?? 7,
      maxHeight: fillSmallerScreens ? '100%' : 'calc(100% - 20px)',
      margin: fillSmallerScreens ? 0 : 'auto 20px',
      top: fillSmallerScreens ? 0 : '50%',
      transform: fillSmallerScreens ? 'translateY(0)' : 'translateY(-50%)',
      boxShadow: fillSmallerScreens ? 'none' : '0px 12px 12px #000',
      ':focus': {
        outline: 'none',
      },

      [media.tablet]: {
        height: fillSmallerScreens ? '100%' : 'fit-content',
        maxHeight: fillSmallerScreens ? '100%' : 'calc(100% - 52px)',
        margin: fillSmallerScreens ? 0 : 'auto 52px',
        padding: styles.modalContent?.tablet?.padding ?? '80px 35px',
      },

      [media.desktop]: {
        top: '50%',
        transform: 'translateY(-50%)',
        height: preventScroll ? '100%' : 'auto',
        borderRadius: styles.modalContent?.borderRadius ?? 7,
        padding: styles.modalContent?.desktop?.padding ?? '80px 69px',
        maxWidth: 811,
        maxHeight: '90%',
        margin: 'auto',
        boxShadow: '0px 12px 12px #000',
      },
    },

    overlay: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0)',
      overflowY: 'auto',
      zIndex: 9999,
      maxHeight: '100vh',
      [media.desktop]: {
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
      },
    },

    close: {
      position: 'absolute',
      zIndex: 1,
      top: 22,
      right: 13,

      [media.desktop]: {
        top: 22,
        right: 18,
      },

      [children('button')]: {
        padding: 0,
        border: 'none',
        background: 'transparent',
      },

      [children('path')]: {
        fill: styles?.closeButton?.color ? styles.closeButton.color : palette.red,
      },
    },

    mainContent: {
      height: '100%',
      overflowY: 'auto',
    },
  });
};
